import LangEnum from '../../../../../../../lang/LangEnum';
import { AvailabilityEnum } from '../../../../../../products/ProductTypes';
import { OfflineOrderProduct } from '../../../orderProduct/OfflineOrderProduct';
import {
  OfflineOrderRulesReturnMap,
  OfflineOrderRulesTo,
  ValidateOfflineOrderRuleParams,
} from '../../OfflineOrderRules.types';
import BaseOrderProductQuantityRule from '../baseOrderProductQuantity.rule';

export default class ReadyForDeliveryMultipleAmountByItemRule extends BaseOrderProductQuantityRule {
  validate({
    order,
    userRole,
  }: ValidateOfflineOrderRuleParams): OfflineOrderRulesReturnMap[OfflineOrderRulesTo.VALIDATE_PRODUCTS] {
    if (this.canUserBypassRule(userRole)) {
      return { hasErrors: false };
    }

    const filtered = this.filterOrderProducts(order.products ?? []);

    filtered.forEach((orderProduct) => {
      this.validateOrderProduct(orderProduct);
    });

    if (!this.orderProductsWithError.length) {
      return {
        hasErrors: false,
      };
    }

    return {
      hasErrors: true,
      error: {
        messageCode: LangEnum.ORDER_PRODUCT_RULE_READY_FOR_DELIVERY_MULTIPLE_AMOUNT_BY_ITEM,
      },
      orderProductsWithError: this.orderProductsWithError,
    };
  }

  private filterOrderProducts(products: OfflineOrderProduct[]): OfflineOrderProduct[] {
    return products.filter(
      (orderProduct) =>
        orderProduct.availability === AvailabilityEnum.READY_FOR_DELIVERY &&
        !!orderProduct.product.rules?.readyForDeliveryMultipleItem,
    );
  }

  private validateOrderProduct(orderProduct: OfflineOrderProduct) {
    const quantity = orderProduct.getTotalGridQuantity();
    const multiple = orderProduct.product.rules?.readyForDeliveryMultipleItem ?? 0;

    const isMultiple = this.validateMultipleOf(quantity, multiple);

    if (!isMultiple) {
      this.pushOrderProductWithError(orderProduct, {
        minimumQuantity: multiple,
      });
    }
  }
}
